module.exports = __webpack_public_path__ + "img/user.455b9fe2.svg";